import { SeatModelBase } from "./seat_model_base";
import { SeatViewBase } from "./seat_view_base";
import { TableEntityBase } from "../table/table_entity_base";
import { SeatConfig } from "../../component/seat_state_component";
import { TableHelp } from "../../help/table_help";
import { Define } from "../../data/const_define";
import { TableData } from "../../data/table_data";
import { Texas } from "../../../../net/proto/proto_texasholdem_game";
import { PokerComponent } from "../../component/poker_component";
import UserDataManager from "../../../../../../manager/user_manager";
import { IUserData } from "../../../../../public/model_data";
import TexasSound from "../../../texas_sound";
import ModuleManager from "../../../../../../framework/core/module_manager";
import { CountUp } from "../../../../../../lib/countUp";

//实体座位(管理model,view)
export class SeatEntityBase extends cc.EventTarget{

    protected modelBase:SeatModelBase;

    protected viewBase:SeatViewBase;

    beloneTable:TableEntityBase;

    //用于牌型的座位排序
    sortID:number;

    //服务器座位ID
    private _serverSeatID;

    isSeat:boolean;//是否坐下

    isAll_in:boolean;//是否是all-in

    get serverSeatID() {
        return this._serverSeatID;
    }

    get playerID(){
        let data = this.modelBase.seatPlayerData
        if (data) {
            return data.player_id;
        }
        return null;
    }

    set serverSeatID(v:number){
        this._serverSeatID = v;
    }

    get isMySelf():boolean{//可以能弃牌
        if (this.seatData) {
            return this.beloneTable.isRole(this.seatData.player_id);
        }
        return false;
    }

    get seatData():TableData.SeatPlayerData{
        return this.modelBase.seatPlayerData;
    }

    set seatData(v:TableData.SeatPlayerData){
        this.modelBase.seatPlayerData = v;
    }

    get playerHands():PokerComponent[]{
        return this.viewBase.playerHands;
    }

    //筹码结束位置
    get betEndNode():cc.Node{
        return this.viewBase.betEndNode;
    }

    get effectNode():cc.Node{
        return this.viewBase.effectNode;
    }

    Init(seatParent:cc.Node,beloneTable:TableEntityBase){
        this.beloneTable = beloneTable;
        this.baseModelInstance();
        this.baseViewInstance(seatParent);
        this.onInit();
    }

    
    baseModelInstance(){
        if (!this.modelBase) {
            this.modelBase = new SeatModelBase();
            this.modelBase.Init();
        }
    }

    baseViewInstance(parent:cc.Node){
        if (!this.viewBase) {
            this.viewBase = new SeatViewBase();
            this.viewBase.seatNode = TableHelp.AddChild(this.beloneTable.seatInfoPrefab,parent);
            this.viewBase.seatNode.zIndex = 0;
            this.viewBase.Init();
        }
    }

    onInit(){
        this.setActiveInfo(false);
        this.setBetState(false);
        this.viewBase.clickNode.on('click',this.showChat.bind(this))
    };

    showChat(){
        let node = this.beloneTable.chatNode;
        if (this.seatData) {
            ModuleManager.instance.showEmojiModule(this.seatData.player_id,'TexasPokerTable')
        }
    }

    getSeatNode():cc.Node{
        return this.viewBase.seatNode;
    }

    //设置信息显示
    setActiveInfo(isShow:boolean){
        this.viewBase.inforNode.active = isShow;
    }

    hideCheckGold(){
        this.setBetState(false);
        this.viewBase.recycleCheckBet();
    }

    //设置金币的显示
    setBetState(isShow:boolean){
        this.viewBase.setBet(isShow);
    }

    getPosition():cc.Vec2{
        return this.viewBase.seatNode.position;
    }

    setMask(isShow:boolean){
        this.viewBase.setMask(isShow);
    }

    setPosition(pos:cc.Vec2){
        this.viewBase.seatNode.position = pos;
    }

    //是否在游戏中
    isPlayingGame(){
        if (this.seatData) {
            if (this.seatData.state != Define.PlayerState.Look_2
                && this.seatData.state != Define.PlayerState.Look_1) {
                return true;
            }
        }
        return false;
    }

    //是否弃牌
    isFold(){
        if (this.seatData) {
            return this.seatData.state == Define.PlayerState.GiveUp
        }
        return true;
    }

    stopAllActions(){
        this.viewBase.seatNode.stopAllActions();
    }

    setDes(str:string){
        this.viewBase.setDes(str);
    }

    setServerActive(isShow:boolean){
        this.viewBase.setServerActive(isShow);
    }

    setTestContent(){
        if (!Define.isDebugMode) {
            return;
        }

    }

    //设置操作描述
    setOperatorDes(value:string,operator:Define.OperatorType){
        if (value) {
            this.viewBase.setOperatorDes(value,operator);
        }
    }

    resumeHands(){
        this.viewBase.resumeHands();
    }

    //准备发牌设置显示
    beginDealCards(){
        this.viewBase.beginDealCards();
    }

    //发牌
    dealCards(s:cc.Node,index:number){
        this.viewBase.dealCards(s,index);
    }

    //弃牌
    throwCardsAction(source:cc.Node){
        this.viewBase.throwCardsAction(source);
    }

    throwCard(){
        if (!this.isMySelf) {
            this.setSmallCard(true);
            this.throwCardsAction(this.beloneTable.dealerNode);
        }
    }

    checkBetAction(goldNumb:number,func?:Function){
        if (goldNumb > 0) {
            this.setBetNumb(goldNumb);
            this.viewBase.checkBetAction(goldNumb,func);
        }
    }

    //归池
    guiChi(target:cc.Node,func?:Function){
        this.viewBase.guiChi(target,func);
    }

    guiChiToEntity(entity:SeatEntityBase,func?:Function){
        this.guiChi(entity.viewBase.betEndNode,func);
    }

    //直接显示下注额
    showBet(gold:number){
        this.setBetNumb(gold);
        this.viewBase.showBet(gold);
    }

    //获得bet
    obtainBet(target:cc.Node,gold:number){
        this.viewBase.obtainBet(target,gold,()=>{
            if (this.seatData) {
                if (this.seatData.obtainBet > 0) {
                    this.viewBase.flyGameLab(true,this.seatData.obtainBet);
                }
                this.updateChips(this.seatData.chips);
                if (this.isWinner) {
                    this.viewBase.setAllInNode(true);
                    TableHelp.delay(this.viewBase.clickNode,()=>{
                        this.viewBase.setAllInNode(false);
                    },1.2) 
                }
            }
        });
    }

    obtainBetNoFlyAction(target:cc.Node,gold:number,func:Function){
        this.viewBase.obtainBet(target,gold,func);
    }

    flyGameLabAction(){
        if (this.seatData) {
            this.viewBase.flyGameLab(true,this.seatData.obtainBet);
            this.updateChips(this.seatData.chips);
        }
    }

    //ui 操作
    //设置金币数
    updateChips(gold:number){
        gold = TableHelp.getRightMount(gold);
        this.viewBase.setGoldNumb(gold);
        let data = this.seatData;
        if (data) {
            let isUpdate = data.state == Define.PlayerState.GiveUp
                            || data.state == Define.PlayerState.None
                            || data.state == Define.PlayerState.Look_2
            if (this.isMySelf) {
                this.beloneTable.updateAddBet(gold <= 0 && isUpdate);
            }
        }
    }

    updateEntityChips(oldChips:number){
        let data = this.seatData;
        if (data) {
            let chouma = new CountUp(null,data.chips,{
                startVal: oldChips,
                decimalPlaces: 2,
                duration: 0.5,
                useEasing: false,
                useGrouping: false,
                smartEasingThreshold: 999,
                smartEasingAmount: 333,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            })
            if(!chouma.error){
                chouma.start((n)=>{
                    if (this.viewBase && this.viewBase.isNoDestroy) {
                        this.updateChips(Number(n));
                    }
                })
            }
            this.viewBase.playGrades(true,data.chips - oldChips);
        }
    }

    //设置下注额
    setBetNumb(bet:number){
        bet = TableHelp.getRightMount(bet);
        this.viewBase.setBetNumb(bet);
    }

    setSmallCard(isShow:boolean){
        this.viewBase.seatComponent.smallPoker.opacity = isShow?255:0;
    }

    moveTo(pos:cc.Vec2,time:number,comp?:Function){
        let node = this.viewBase.seatNode;
        node.stopAllActions();
        TableHelp.moveToAction(node,pos,time,comp);
    }


    //玩家站起
    playerStandUp(){
        this.resetInfoNode();
        this.setActiveInfo(false);
        this.isSeat = false;
        let seatData = this.seatData;
        if (seatData) {
            if (this.beloneTable.isRole(seatData.player_id)) {
                if (this.beloneTable.boardData.gameState == Define.NextAction.No_opening
                    || seatData.state == Define.PlayerState.Look_1) {
                    this.beloneTable.setHandState(false);
                }else{
                    this.beloneTable.throwCardsAction();
                }
            }
        }
        this.seatData = null;
    }

    //玩家坐下
    playerSitDown(){
        this.isSeat = true;
        this.setPlayerState();
        this.setActiveInfo(true);
        this.setTestContent();
        //请求名字
        let data = this.seatData;
        if (data) {
            //设置玩家名字
            this.setPlayerName();
            //头像获取
            UserDataManager.getData(data.player_id,(data:IUserData)=>{
                if (this.viewBase.seatNode && this.viewBase.seatNode.isValid) {
                    this.seatData.playerName = data.name || '';

                    if ((this.seatData.betState == 0  || this.seatData.betState == undefined)
                        && (this.seatData.state == 1
                            || this.seatData.state == 5)) {
                        this.setOperatorDes(data.name,Define.OperatorType.Name_Op);
                    }

                    this.viewBase.setPlayerInfo(data);
                }
            })
        }

        if (Define.isDebugMode) {
            if (!this.isMySelf) {
                this.showHandDirector();
            }
        }
    }

    setPlayerName(){
        if (this.seatData) {
            if ((this.seatData.betState == 0  || this.seatData.betState == undefined)
            && (this.seatData.state == 1 || this.seatData.state == 5)) {
                this.setOperatorDes(this.seatData.playerName,Define.OperatorType.Name_Op);
            }
        }
    }

    //每轮结束调用，结束不需要
    roundOver(){
        let data = this.seatData;
        if (data) {
            if (data.state == 2) {//all-in
                //全压或者弃牌无需更新状态
            }else{
                this.setOperatorDes(data.playerName,Define.OperatorType.Name_Op)
            }
            data.betState = 0;//清空状态
            if (data.state == Define.PlayerState.All_in) {
                data.state = Define.PlayerState.Fighting
            }
            //data.state = Define.PlayerState.Fighting;//战斗状态
        }
    }

    hideOpTimeState(){
        this.viewBase.cancleSlider();
        this.viewBase.hideOpTimeState();
    }
    //当前玩家执行动作
    presentSeatAction(action:Texas.INextPlayerAction){
        this.setPlayerState();
        this.setOpTime(action.opTime);
    }
    //上一个玩家执行动作
    previousSeatAction(action:Texas.IPlayerAction,nexaction?:Texas.INextAction){
        this.hideOpTimeState();
        this.setPlayerState();
        if (action.decision == Define.TableSeatAction.All_in) {
            //this.viewBase.setAllInNode(true);
            TexasSound.allinSound();
            this.setOperatorDes('7',Define.OperatorType.Image_Op);
        }else{
            this.setOperatorDes(action.decision.toString(),Define.OperatorType.Image_Op);
        }
        if (this.isNeedAnim()) {
            this.doAction(action.decision);
        }
        if (action.decision == Define.TableSeatAction.Raise
            || action.decision == Define.TableSeatAction.Call
            || action.decision == Define.TableSeatAction.All_in) {
            if (this.isNeedAnim()) {
                this.updateBetNumb(true);
            }else{
                let data = this.seatData;
                if (data) {
                    this.setBetNumb(data.bet);
                    this.setBetState(true);  
                }
            }
        }

        if (action.decision == Define.TableSeatAction.Fold) {
            this.throwCard();
        }

        //更新余额
        this.updateChips(this.seatData.chips);
        this.beloneTable.commonData.isNeedAnim = true;
    }

    //是否需要动画
    private isNeedAnim(){
        if (this.isMySelf && !this.beloneTable.commonData.isNeedAnim) {
            return false;
        }
        return true;
    }


    private doAction(decision:number){
        if (decision == Define.TableSeatAction.Fold) {
            TexasSound.playFold()//弃牌
            if (!this.isMySelf) {
                this.throwCardsAction(this.beloneTable.dealerNode);
            }
        }else if (decision == Define.TableSeatAction.Check) {
            TexasSound.playCheck();//让牌
        }else if (decision == Define.TableSeatAction.Raise
            || decision == Define.TableSeatAction.All_in
            || decision == Define.TableSeatAction.Call) {
            //TexasSound.playBet();
        }
    }

    //公共牌和手牌组成最大牌型
    updateMyMaxCardType(maxcardInfo:Texas.IMaxCardInfo){
        let data = this.seatData;

        if (data.state == Define.PlayerState.GiveUp
            || data.state == Define.PlayerState.Look_2) {//已经弃牌，坐下
            return;
        }
 
        //reset
        let commonPokers = this.beloneTable.commonPokers.pokers;
        let pokers = commonPokers.concat(this.beloneTable.playerHands);
        for (let pk of pokers) {
            pk.showCardOnly();
            let isHeight = false;//是否高亮
            for (let card of maxcardInfo.highLightCards) {
                if (pk.code == card) {
                    isHeight = true;
                    break;
                }
            }
            if (isHeight) {
                pk.showPokerState(true);
            }
            //显示最大牌型
            this.showMaxCards(pk,maxcardInfo.maxCards);
        }
        this.beloneTable.showCardsType(maxcardInfo.maxCardsType);
    }

    //弃牌更新最大牌型
    foldUpdateMaxCardType(maxcardInfo:Texas.IMaxCardInfo){
        let data = this.seatData;

        if (data.state == Define.PlayerState.Look_2) {//已经弃牌，坐下
            return;
        }
 
        //reset
        let commonPokers = this.beloneTable.commonPokers.pokers;
        let pokers = commonPokers.concat(this.beloneTable.playerHands);
        for (let pk of pokers) {
            pk.showCardOnly();
            let isHeight = false;//是否高亮
            for (let card of maxcardInfo.highLightCards) {
                if (pk.code == card) {
                    isHeight = true;
                    break;
                }
            }
            if (isHeight) {
                pk.showPokerState(true);
            }
            //显示最大牌型
            this.showMaxCards(pk,maxcardInfo.maxCards);
        }
        this.beloneTable.showCardsType(maxcardInfo.maxCardsType);
        for (let poker of this.beloneTable.playerHands) {
            poker.showBlack(true);
        }
    }

    //设置玩家状态
    setPlayerState(){
        let data = this.seatData;
        if (!data) {
            return;
        }
        let state = data.state;
        this.setMask(false);
        this.setSmallCard(!this.beloneTable.isRole(data.player_id))//控制small
        this.updateChips(data.chips);
        this.viewBase.colorSlider.hide();
        //this.setServerIndex(data.player_pos);
        if (state == Define.PlayerState.All_in) {
            this.setMask(false);
            //this.viewBase.setAllInNode(true);
            this.setOperatorDes('7',Define.OperatorType.Image_Op);
        }else if (state == Define.PlayerState.GiveUp) {
            this.setMask(true);
            this.setSmallCard(false);
            this.setOperatorDes('3',Define.OperatorType.Image_Op);
            this.viewBase.cancleSlider()
            this.viewBase.hideOpTimeState();
        }else if (state == Define.PlayerState.Look_1) {
            
        }else if (state == Define.PlayerState.Look_2) {
            this.setMask(true);
            this.setSmallCard(false);
            this.handSeatData((e:TableData.SeatPlayerData)=>{
                this.setHandState(e.player_id,false);
            })

        }
    }

    //设置操作时间
    setOpTime(time:number){
        if (time < 0) {
            return;
        }
        if (this.seatData) {
            let isPlayer = this.beloneTable.isRole(this.seatData.player_id);
            this.viewBase.setOpTime(time,isPlayer);
        }
    }

    updateSeatInfo(seatConfig:SeatConfig){
        let ui = this.viewBase.seatComponent;
        if (ui) {
            ui.updateSeatInfo(seatConfig);
        }
    }

    //直接显示牌值
    showHandDirector(){
        let data = this.seatData;
        if (data) {
            let cards = data.cards;
            if (cards && cards.length >= 2) {
                if (cards[0] > 0) {
                    this.viewBase.showHands(true);
                    for (let i = 0; i < 2; i++) {
                        let hand = this.playerHands[i];
                        hand.reset();
                        hand.code = cards[i];
                        hand.showCardOnly();
                    }
                }
            }
        }
    }

    isWinner:boolean = false;
    private isShowEndLight :boolean = false;
    isStartMove:boolean = false;//是否移动了
    //最后亮牌
    showEndHands(cards:number[],type:number){
        //亮牌的时候
        this.viewBase.cancleSlider()
        this.viewBase.hideOpTimeState();
        this.setSmallCard(false);
        this.setMask(false);
        this.viewBase.showHands(true);
        if (!this.isMySelf) {//排除我方
            let sound = true;
            for (let i = 0; i < 2; i++) {
                let hand = this.playerHands[i];
                let smallCard = this.viewBase.smallCards[i];
                hand.reset();
                hand.code = cards[i];
                hand.showBack();
                let node = hand.node;
                node.stopAllActions();
                let cardPos = smallCard.parent.convertToWorldSpaceAR(smallCard.position);
                let localPos = node.parent.convertToNodeSpaceAR(cardPos);
                node.position = localPos;
                node.setScale(0.3,0.3);
                node.angle = this.viewBase.smallCardsAngle[i];

                let time = Define.handsMoveTime;
                let moveTo = cc.moveTo(time,this.viewBase.pokerPos[i]);
                let scalTo = cc.scaleTo(time,Define.handsScalTo);

                let callFunc = cc.callFunc(()=>{
                    TableHelp.rotateActionEx(node,0.1,0.2,()=>{
                        if (sound) {
                            TexasSound.playRotatePoker();
                            sound = false;
                        }
                        hand.showPoker();
                        if (type) {
                            this.viewBase.showMaxCardType(type);
                            if (!this.isWinner) {
                                this.viewBase.showMaxCardNode(true);
                            }
                            this.isShowEndLight = true;
                        }
                    },null)
                })

                let spawn = cc.spawn(moveTo,scalTo);
                let seq1 = cc.sequence(spawn,callFunc);
                node.runAction(seq1);
            }
        }else{
            //移动自身头像
            this.beloneTable.showTypeNode(false);
            for (let idx = 0; idx < 2; idx++) {
                let hand = this.playerHands[idx];
                hand.hide();
                hand.code = cards[idx];
                cc.log('---->>>>>开始移动')
                this.beloneTable.movePokers(idx,hand.node,()=>{
                    hand.showCardOnly();
                    this.isStartMove = true;
                    cc.log('---->>>>>移动完成')
                    if (type) {
                        this.viewBase.showMaxCardType(type);
                        if (!this.isWinner) {
                            this.viewBase.showMaxCardNode(true);
                        }
                        this.isShowEndLight = true;
                    }
                });
            }
        }
    }

    showMaxCardNode(isShow:boolean){
        let data = this.seatData;
        if (data.state == 2) {
            this.viewBase.showMaxCardNode(false);
        }else{
            this.viewBase.showMaxCardNode(isShow);
        }
    }

    //赢家动画
    showWinAnim(maxCardsType:number,animEnd:Function){
        this.viewBase.showMaxCardNode(false);//飘分时需隐藏牌型类型
        //动画结束更新票分
        this.viewBase.showWinAnim(maxCardsType,()=>{
            if (animEnd) {
                animEnd();
            }
        })
    }

    //延时显示动画
    delayShowWinAnim(maxCardsType:number,animEnd:Function){
        TableHelp.delay(this.viewBase.betEndNode,()=>{
            this.showWinAnim(maxCardsType,animEnd);
        },0.8)
    }

    isFighting():boolean{
        if (this.seatData) {
            if (this.seatData.state != Define.PlayerState.GiveUp
                && this.seatData.state !=  Define.PlayerState.Look_2
                && this.seatData.state != Define.PlayerState.Look_1) {
                    return true;
            }
        }
        return false;
    }

    //开始处理边池,必定有手牌
    startHandlSidePot(isfold?:boolean){
        //取消计时器
        this.viewBase.cancleSlider();
        this.viewBase.setAllInNode(false);
        //重置手牌
        if (this.isShowEndLight) {//没有结算动画的时候直接显示牌型即可
            //this.viewBase.showMaxCardNode(true);
        }
        let data = this.seatData;
        if (data.state !=  Define.PlayerState.GiveUp) {
            // if (this.isMySelf) {
            //     this.beloneTable.showTwoHandsOnly();
            // }else{
            //     this.showHandDirector();
            // }
            if (!isfold) {//不是弃牌结算
                this.showHandDirector();
            }
        }
    }

    isShowWinAnim(isShow:boolean){
        this.viewBase.isShowWinAnim(isShow);
    }

    //显示最大牌型,结束时使用
    showMaxPattern(maxPattern:Texas.IMaxCardInfo){
        //处理公共牌
        let commonPokers = this.beloneTable.commonPokers.pokers;
        let heightLight = maxPattern.highLightCards.concat([]);
        for (let card of commonPokers) {
            card.showCardOnly();
            let isHeight = false;
            for (let v of heightLight) {
                if (card.code == v) {//高亮
                    isHeight = true;
                    break;
                }
            }
            if (isHeight) {
                card.showPokerState(true)
            }else{//高亮
                var index = heightLight.indexOf(card.code);
                if(index > -1) {
                    heightLight.splice(index,1);
                }
                card.movePoker();//移动
            }
        }

        if (this.isMySelf) {
            if (maxPattern.maxCardsType == 10) {//皇家同花顺
                TexasSound.playWinEx();
            }
        }

        let hands = this.playerHands//this.isMySelf ? this.beloneTable.playerHands:this.playerHands;

        for (let card of hands) {
            card.showCardOnly();
            let isHeight = false;
            for (let v of heightLight) {
                if (card.code == v) {//高亮
                    isHeight = true;
                    break;
                }
            }
            if (isHeight) {
                card.showPokerState(true);
            }
        }

        let pokers = commonPokers.concat(hands);
        for (let pk of pokers) {
            this.showMaxCards(pk,maxPattern.maxCards);
        }
    }

    //显示最大牌
    private showMaxCards(poker:PokerComponent,maxCards:number[]){
        //最大牌型
        let isMaxCard = false;
        for (let maxCard of maxCards) {
            if (maxCard == poker.code) {//最大牌型
                isMaxCard = true;
                break;
            }
        }
        if (!isMaxCard) {
            //poker.blackPoker(); //去掉值黑
        }
    }

    //赢主 显示牌型
    win(winner:TableData.IWinnerPlayer){
        let feeGold = winner.feeGold || 0;
        let obtainBet = winner.obtainChips-feeGold
        this.seatData.chips += obtainBet
        this.seatData.obtainBet = obtainBet;
    }

    //输家(参与牌局的玩家)
    lose(data:TableData.IWinnerPlayer){
        this.viewBase.winner.active = false;
        this.updateChips(this.seatData.chips);
    }

    //更新下注金额
    updateBetNumb(isShowAnim:boolean){
        let data = this.seatData;
        if (data) {
            this.updateTableBet(data.bet,isShowAnim);
        }
    }

    updateTableBet(numb:number,isShowAnim:boolean){
          //设置押注金额
        if (isShowAnim) {
            this.checkBetAction(numb);
        }else{
            this.showBet(numb);
        }
        this.setBetState(true);  
    }

    //更新玩家操作状态
    updateOperatorState(protoData:Texas.IGameInfo){
        let data = this.seatData;
        if (data) {
            //下注
            if (data.bet > 0) {//
                this.updateBetNumb(true);
            }
        }
    }

    showHandRapid(update?:boolean){
        let data = this.seatData;
        if (data) {
            //设置手牌 
            if (this.isMySelf) {
                this.beloneTable.showTwoHands(data.cards);
                this.beloneTable.setHandState(true);
                this.beloneTable.resumeHands();
                if (data.state == Define.PlayerState.GiveUp) {
                    this.beloneTable.maskHands();
                    if (update) {
                        // let publics = this.beloneTable.boardData.cards;
                        // if (data.cardType != 0 && publics && publics.length >= 3) {
                        //     this.beloneTable.showCardsType(data.cardType);
                        // }
                        //this.updateMyPatterner();
                    }
                }
                this.updateMyPatterner();
            }
            //重置手牌
            this.resumeHands();
        }
    }

    //更新我方牌型
    updateMyPatterner(){
        let data = this.seatData;
        let publics = this.beloneTable.boardData.cards;
        if (data && data.cardType != 0 && publics) {
            if (publics.length == 0) {
                if (data.cardType == 2) {//一对
                    this.beloneTable.showCardsType(data.cardType);
                }
            }else if (publics.length >= 3) {
                this.beloneTable.showCardsType(data.cardType);
            }
        }
    }

    //开始游戏操作
    beginGame(protoData:Texas.IGameInfo,tkplayerid:number){
        //设置大小盲
        let data = this.seatData;
        if (data) {
            //更新玩家状态
            if (data.betState != undefined && data.betState != 0) {
                this.setOperatorDes(data.betState.toString(),Define.OperatorType.Image_Op);
            }

            if (data.state == Define.PlayerState.All_in) {
                //this.viewBase.setAllInNode(true);
            }else if (data.state == Define.PlayerState.GiveUp) {//弃牌
                this.setOperatorDes('3',Define.OperatorType.Image_Op);
                this.setSmallCard(false);
            }

            //刷新金币
            if (data.bet > 0) {//
                this.updateBetNumb(false);
            }
            this.showHandRapid();
        }
    }

    //离开牌桌
    leaveGame(playerID:number){
       this.isSeat = false;
       this.setHandState(playerID,false);
       this.seatData = null;
    }

    private handSeatData(func:Function){
        let data = this.seatData;
        if (data) {
            func(data);
        }
    }

    private setHandState(playerID:number,isShow:boolean){
        if (this.beloneTable.isRole(playerID)) {
            this.beloneTable.setHandState(isShow);
        }
    }

    private resetInfoNode(){
        this.hideOpTimeState();
        this.setSmallCard(false);
    }
    //重置
    reset(){
        this.isWinner = false;
        this.isAll_in = false;//控制all-in动画
        this.isShowEndLight = false;
        this.isStartMove = false;
        //有数据代表有名字
        this.setOperatorDes('',Define.OperatorType.Name_Op);
        this.setActiveInfo(false);
        this.setServerActive(false)
        this.isSeat = false;
        this.viewBase.reset();
        this.resetInfoNode();
        this.seatData = null;//置空数据
    };
    //游戏结束时清理
    gameOverClear(){
        if (this.seatData) {
            this.setOperatorDes(this.seatData.playerName,Define.OperatorType.Name_Op);
            //修改状态结算了
            this.seatData.state = Define.PlayerState.Look_2;
            this.seatData.betState = 0
            this.seatData.cardType = 0;
            this.seatData.cards = [];//结束牌值
        }else{
            this.setActiveInfo(false);
            this.isSeat = false;
        }
        this.isShowEndLight = false;
        this.isStartMove = false;
        this.viewBase.reset();
        this.resetInfoNode();
        this.setBetState(false);
    }

    clear(){
        this.reset();
        this.viewBase.clear();
    }

}
